<div class="header-absolute"></div>
<div class="sigma_banner banner-3">
    <!-- Custom Arrows Start -->
    <div class="sigma_arrows sigma_arrows-transparent">
        <div class="sigma_round-arrow prev-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="125px" height="125px" viewBox="0 0 197 197" enable-background="new 0 0 197 197" xml:space="preserve">
                <circle class="sigma_round-arrow-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>
                <circle class="sigma_round-arrow-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>
            </svg>
            <i class="far fa-arrow-left slick-arrow slider-prev"></i>
        </div>
        <div class="sigma_round-arrow next-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="125px" height="125px" viewBox="0 0 197 197" enable-background="new 0 0 197 197" xml:space="preserve">
                <circle class="sigma_round-arrow-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>
                <circle class="sigma_round-arrow-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5"></circle>
            </svg>
            <i class="far fa-arrow-right slick-arrow slider-next"></i>
        </div>
    </div>
    <!-- Custom Arrows End -->
    <!-- <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="sigma_banner-slider">
      
        <div ngxSlickItem class="light-bg sigma_banner-slider-inner bg-cover bg-center bg-norepeat dark-overlay" [style.background-image]="'url('+item.image+')'" *ngFor="let item of banner">
            <div class="sigma_banner-text">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <h4 class="text-white">{{item.subtitle}}</h4>
                            <h1 class="title text-white">{{item.title}}</h1>
                            <p>{{item.text}}</p>
                            <div class="section-button d-flex align-items-center">
                                <a routerLink="/about" class="sigma_btn-custom">About Company</a>
                                <a routerLink="/contact" class="ml-3 sigma_btn-custom secondary">Get a Quote </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
    </ngx-slick-carousel> -->
</div>